module.exports = {"AED":{"code":"AED","name":"UAE Dirham","rate":"1.000000"}}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/data/currencies.json
// module id = 1702
// module chunks = 2